<template>
    <nav class="navbar main-navbar pt-3">
        <form class="form-inline mr-auto">
            <ul class="navbar-nav mr-3 home-d">
                <li v-on:click="menuOptions()">
                    <a href="#" data-toggle="sidebar" class="nav-link nav-link-lg">
                        <i v-if="menu" class="uil uil-bars"></i>
                        <i v-if="!menu" class="uil uil-bars"></i>
                    </a>
                </li>
            </ul>
            <div class="search-element d-flex align-items-center">
                <template v-if="user.level !== 1">
                    <i class="slot-i uil uil-ticket"></i>
                    <div class="ml-3">Your Slot : {{slots}}</div>
                    <a v-if="formprofile.parent === null" target="_blank" href="https://wa.me/6281337589348?text=Halo, Saya Mau Beli Slots" class="add-slot"><i class="uil uil-plus"></i> Add Slot</a>
                </template>
                <template  v-if="user.level === 1">
                    <i class="slot-i  uil uil-calendar-alt"></i>
                    <div class="ml-3">{{datenow}}</div>
                </template>
              
            </div>
        </form>
        
        <div class="navbar-nav navbar-right">
            <li v-on:click="dropdownUser()" :class="{'show': dropdown_profile === true}" class="dropdown">
                <a href="#" v-on:click.prevent="" v-if="user" data-toggle="dropdown" class="nav-link dropdown-toggle nav-link-lg nav-link-user">
                    <div class="d-sm-none d-lg-inline-block nav-name mr-3">Hi, {{user.name}}</div>
                    <img alt="image" v-if="user.photo" :src="user.photo" class="rounded-circle">
                    <img alt="image" v-if="!user.photo" src="@/assets/img/user.png" class="rounded-circle">
                </a>
                <div class="dropdown-menu dropdown-menu-right" :class="{'show': dropdown_profile === true}">
                    <router-link class="dropdown-item has-icon" :to="{ name: 'profile' }">
                        <i class="lnr lnr-cog"></i> Profile Settings
                    </router-link>
                    <div class="dropdown-divider"></div>
                    <a v-on:click.prevent="logout()" href="#" class="dropdown-item has-icon text-danger">
                        <i class="lnr lnr-exit"></i> Log out
                    </a>
                </div>
            </li>
        </div>

        <template v-if="formprofile.challenge">
            <b-modal id="modal-Confirm-Challenge" size="md" class="modal-form" title="Detail Challenge" centered hide-footer hide-header>
                <div class="text-center px-4 py-5">
                    <img class="img-ac rounded vert-move mb-4" :src="require('@/assets/img/challenge.png')" alt="product">
    
                    <h4>Hi {{formprofile.name}} !!</h4>
                    <p>Congratulations you have been chosen as a participant challenge <strong>{{formprofile.challenge.name}}</strong></p>
                    <button class="btn btn-primary" @click="_confirmChallenge(formprofile.challenge.participant_id)">Go to Leaderboard </button>
                </div>
            </b-modal>
        </template>
   
        <template v-if="formprofile.achievement">
            <b-modal id="modal-Confirm-Achievement" size="md" class="modal-form" title="Detail Achievement" centered hide-footer hide-header>
                <div class="text-center px-4 py-5">
                    <img class="img-ac rounded vert-move mb-4" :src="require('@/assets/img/winner.png')" alt="product">
                    <h4>Hi {{formprofile.name}} !!</h4>
                    <p>Congratulations, you were chosen to be a winner as <strong>{{formprofile.achievement.achievement_name}}</strong> in the <strong>{{formprofile.achievement.challenge_name}}</strong> challenge</p>
                    <button class="btn btn-primary" @click="_confirmAchievement(formprofile.achievement.achievement_id)">Go to Leaderboard </button>
                </div>
            </b-modal>
        </template>
    
    </nav>
</template>

<script>
    import { mapState, mapMutations, mapActions } from 'vuex'
    import moment from 'moment'
    
    export default {
        data(){
            return{
                isActive: false,
                dropdown_profile:false,
                window_width:0,
            }
        },
        created(){
            this.getProfile()
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
        watch:{
            'formprofile.achievement':function(val){
                if(val !== null){
                    this.$bvModal.show('modal-Confirm-Achievement')
                }
            },
            'formprofile.challenge':function(val){
                if(val !== null){
                    this.$bvModal.show('modal-Confirm-Challenge')
                }
            }
        },
        computed : {
            ...mapState('AuthControl', {
                user: state => state.user,
                menu: state => state.menu,
            }),
            ...mapState('UsersControl', {
                slots: state => state.slots,
                formprofile: state => state.formprofile,
            }),

            datenow: function(){
                var date = new Date();
                return moment(String(date)).format('DD MMMM YYYY')
            }
        },
        methods: {
            ...mapMutations('AuthControl', ['CHANGE_MENU']),
            ...mapActions('AuthControl', ['getUserLogin']),
            ...mapActions('UsersControl', ['getProfile','confirmChallenge','confirmAchievement']),
            

            handleResize() {
                this.window_width = window.innerWidth;
                if(this.window_width < 768){
                    this.CHANGE_MENU(false)
                }
            },
            logout: function () {
                this.$store.dispatch('AuthControl/logout').then(() => {
                    this.$router.push('/login')
                })
            },
            menuOptions: function(){
                if(this.menu == true){
                    this.CHANGE_MENU(false)
                }else{
                    this.CHANGE_MENU(true)
                }
            },
            dropdownUser:function(){
                if(this.dropdown_profile == false){
                    this.dropdown_profile = true
                }else{
                    this.dropdown_profile = false
                }
            },
            _confirmChallenge:function(id_participant){
                this.confirmChallenge(id_participant).then(() => {
                    this.$router.push({name : 'agent-leaderboard'})
                    this.$bvModal.hide('modal-Confirm-Challenge')
                }).catch((error) => {
                    console.log(error)
                })
            },
            _confirmAchievement:function(id_achievement){
                this.confirmAchievement(id_achievement).then(() => {
                    this.$router.push({name : 'agent-leaderboard'})
                    this.$bvModal.hide('modal-Confirm-Achievement')
                }).catch((error) => {
                    console.log(error)
                })
            }
        },
    }
    
</script>